<template>
    <div class="product-details-canvas">
      <!-- Main Framework Wrapper Container -->
      <div class="container py-3 py-md-5">
        <div class="row">
          
          <!-- Left Structural Column: Hero Image Media Stage Layer -->
          <section class="col-12 col-md-6 mb-4 mb-md-0">
            <div class="media-gallery-wrapper">
              <!-- Stage Focal Display Panel with Dynamic Graphic Texture Lines Background -->
              <!-- <div class="hero-stage-panel position-relative">
                <button class="back-navigation-btn position-absolute" aria-label="Go back to previous page">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <img :src="activeImage" :alt="product.title" class="img-fluid active-showcase-asset" />
                <span class="slide-indicator-badge position-absolute">
                  {{ activeImageIndex + 1 }}/{{ product.images.length }}
                </span>
              </div> -->
              <div 
                class="hero-stage-panel position-relative" 
                @click="advanceToNextImage"
                style="cursor: pointer;"
                title="Click to view next image"
                >
                    <!-- Back Backwards Navigation Arrow Button Trigger -->
                    <button class="back-navigation-btn position-absolute" @click.stop="triggerBackAction" aria-label="Go back to previous page">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </button>

                    <!-- Central Active Image View Holder Display Box -->
                    <img :src="activeImage" :alt="activeProduct.title" class="img-fluid active-showcase-asset" />

                    <!-- Floating Slide Index Track Indicator Ring Marker Badge -->
                    <span class="slide-indicator-badge position-absolute">
                        {{ activeImageIndex + 1 }}/{{ activeProduct.images.length }}
                    </span>
                </div>
              
              <!-- Hidden alternate thumbnails engine array path (Ready for full-size slider loops) -->
              <div class="hidden-thumbnail-preloader-rail d-none">
                <button 
                  v-for="(img, idx) in activeProduct.images" 
                  :key="idx" 
                  @click="switchActiveImageIndex(idx)"
                ></button>
              </div>
            </div>
          </section>
  
          <!-- Right Structural Column: Core Metadata Descriptor Block & Specifications -->
          <section class="col-12 col-md-6 d-flex flex-column justify-content-between">
            <div class="product-metadata-block">
              <!-- Product Main Title Header Specification Mapping -->
              <h1 class="product-title-header mb-2">{{ activeProduct.title }}</h1>
  
              <!-- Rating Score and Social Review Aggregation Metrics Row Row -->
              <!-- <div class="rating-review-metrics-row d-flex align-items-center gap-2 mb-3">
                <div class="score-badge-pill d-flex align-items-center gap-1">
                  <span class="star-icon-solid">★</span>
                  <span class="rating-value-bold">{{ product.ratingScore }}</span>
                </div>
                <span class="review-total-count text-muted">
                  ({{ product.reviewCount }} reviews)
                </span>
                <span class="divider-dot">•</span>
                <span class="availability-status-tag">In Stock</span>
              </div> -->
  
              <!-- Merchant Verification Authorization Partner Strip Row -->
              <div class="merchant-partnership-row text-muted mb-4">
                Sold by <span class="merchant-highlight-name">{{ activeProduct.merchant_name }}</span> 
                <span class="partnership-badge-tag">(Official Partner)</span>
              </div>

              <div class="merchant-partnership-row text-muted mb-4">
                Description: <span class="merchant-highlight-name">{{ activeProduct.description }}</span> 
              </div>
  
              <!-- Specifications Grid Layer Table Box Mapping Mockup Properties -->
              <!-- <div class="specifications-matrix-table mb-5">
                <h3 class="specification-title-label mb-3">Specifications</h3>
                
               
                <div class="spec-data-row d-flex justify-content-between py-2 border-bottom">
                  <span class="spec-property-label text-muted">Dimensions</span>
                  <span class="spec-value-content-text text-dark font-weight-bold">
                    {{ product.specifications.dimensions }}
                  </span>
                </div>
  
               
                <div class="spec-data-row d-flex justify-content-between py-2 border-bottom">
                  <span class="spec-property-label text-muted">Material</span>
                  <span class="spec-value-content-text text-dark font-weight-bold">
                    {{ product.specifications.material }}
                  </span>
                </div>
              </div> -->

                <div class="product-details-extended">
                    <div class="container py-3 py-md-4">
                    <div class="row">
                        <div class="col-12 mx-auto">
                        
                        <!-- Payment Plan Section Matrix Grid -->
                        <section class="payment-plan-card mb-4">
                            <h3 class="section-title-label mb-3">Payment <span v-if="activeProduct.payment_type == 'payment_plan'">Plan</span></h3>

                            <div v-if="activeProduct.payment_type === 'payment_plan'" class="plan-data-row d-flex justify-content-between align-items-center py-3 border-bottom">
                              <span class="plan-property-label text-muted"><span>{{  }}</span> Item Price</span>
                              <span class="plan-value-highlight text-primary font-weight-bold">
                                ₦{{ formatPrice(activeProduct.price || 0)}}
                              </span>
                            </div>
                            <div  v-if="activeProduct.payment_type === 'payment_plan'" class="plan-data-row d-flex justify-content-between align-items-center py-3 border-bottom">
                              <span class="plan-property-label text-muted">Down Payment</span>
                              <span class="plan-value-highlight text-primary font-weight-bold">
                                  ₦{{ formatPrice(activeProduct.down_payment_actual_value) }}
                              </span>
                            </div>

                            <div v-if="activeProduct.payment_type === 'payment_plan'" class="plan-data-row d-flex justify-content-between align-items-center py-3 border-bottom">
                              <span class="plan-property-label text-muted">Payment Duration</span>
                              <span class="plan-value-highlight text-primary font-weight-bold">
                                  {{ activeProduct.payment_duration || 0}} <span>{{ activeProduct.payment_frequency == 'weekly' ? 'Week(s)' : 'Month(s)' }}</span>
                              </span>
                            </div>

                            <!-- <div v-if="activeProduct.payment_type === 'payment_plan'" class="plan-data-row d-flex justify-content-between align-items-center py-3 border-bottom">
                              <span class="plan-property-label text-muted"><span>{{  }}</span> Installment</span>
                              <span class="plan-value-highlight text-primary font-weight-bold">
                                ₦{{ formatPrice(activeProduct.monthly_installment || 0)}}
                              </span>
                            </div> -->

                            <!-- <div class="plan-data-row d-flex justify-content-between align-items-center py-3 border-bottom">
                              <span class="plan-property-label text-muted">Remaining Balance</span>
                              <span class="plan-value-highlight text-primary font-weight-bold">
                                ₦{{ formatPrice(paymentInfo.monthlyAmount) }}
                              </span>
                            </div> -->

                            <div class="plan-data-row d-flex justify-content-between align-items-center py-3 border-bottom">
                              <span class="plan-property-label">Total </span>
                              <span v-if="activeProduct.payment_type === 'payment_plan'" class="plan-value-highlight text-primary font-weight-bold" style="color: #0022ba !important;">
                                ₦{{ formatPrice(activeProduct.down_payment_actual_value) }}
                              </span>
                              <span v-if="activeProduct.payment_type === 'outright_payment'" class="plan-value-highlight text-primary font-weight-bold" style="color: #0022ba !important;">
                                ₦{{ formatPrice(activeProduct.price) }}
                              </span>
                            </div>
                        </section>

                        <!-- Merchant Profile Information Block -->
                        <section class="merchant-profile-card d-flex align-items-center gap-3 p-3 mb-5">
                            <div class="merchant-avatar-wrapper position-relative">
                            <img :src="merchant.avatarUrl" :alt="merchant.name" class="merchant-avatar-img" />
                            </div>
                            <div class="merchant-details-meta">
                            <span class="merchant-badge-label uppercase-text text-muted d-block">Merchant</span>
                            <h4 class="merchant-name-title m-0">{{ activeProduct.merchant_name }}</h4>
                            </div>
                        </section>

                        <!-- Reviews Loop Feed Section Layout -->
                        <section class="customer-reviews-section d-none">
                            <h3 class="section-title-label mb-4">What customers say</h3>
                            
                            <div class="reviews-feed-list">
                            <article 
                                v-for="review in reviews" 
                                :key="review.id" 
                                class="review-item-block py-3 border-bottom"
                            >
                                
                                <header class="review-header-row d-flex justify-content-between align-items-center mb-2">
                                <div class="reviewer-meta d-flex align-items-center gap-2">
                                    <div class="reviewer-initials-avatar d-flex align-items-center justify-content-center">
                                    {{ getInitials(review.authorName) }}
                                    </div>
                                    <h5 class="reviewer-name-text m-0">{{ review.authorName }}</h5>
                                </div>
                                
                                <!-- Stars Row Track Modifier -->
                                <div class="review-stars-row d-flex gap-1">
                                    <span 
                                    v-for="star in 5" 
                                    :key="star" 
                                    class="star-glyph"
                                    :class="{ 'is-filled': star <= review.ratingScore }"
                                    >★</span>
                                </div>
                                </header>

                                <!-- Review Content Paragraph Text Core Block -->
                                <div class="review-body-content">
                                <p class="review-text-paragraph text-muted m-0">
                                    "{{ review.comment }}"
                                </p>
                                </div>
                            </article>
                            </div>
                        </section>

                        </div>
                    </div>
                    </div>
                </div>
            </div>
  
            <!-- Core Operational Purchase Sticky Call-To-Action Foot Panel Row -->
            <footer class="action-docking-row d-flex align-items-center gap-2 pt-3 mt-auto">
              <!-- Quick Buy Instant Activation Checkout Processing CTA Button -->
              <button 
                class="buy-now-action-cta-btn flex-grow-1"
                :disabled="isProcessingBuy"
                @click="dispatchInstantBuyTerminal; openSelectionModal()"
              >
                <span v-if="!isProcessingBuy">Buy Now</span>
                <span v-else>Connecting to payment...</span>
              </button>
  
              <!-- Bucket Selection Add-To-Cart Icon Trigger Dock Modifier Button Button -->
              <!-- <button 
                class="cart-bucket-append-dock-btn d-flex align-items-center justify-content-center"
                :disabled="isProcessingCart"
                @click="dispatchCartAppendPipeline"
                :aria-label="'Append item selection to cart bucket'"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  <line x1="12" y1="9" x2="12" y2="15"></line><line x1="9" y1="12" x2="15" y2="12"></line>
                </svg>
              </button> -->
            </footer>
          </section>

          <!-- Payment Sellection modal -->
          <div 
            class="modal fade" 
            id="paymentSelectionModal" 
            tabindex="-1" 
            role="dialog" 
            aria-hidden="true"
            ref="selectionModal"
          >
            <div class="modal-dialog modal-dialog-centered custom-modal-enclosure" role="document">
              <div class="modal-content custom-modal-card p-3 p-sm-4">
                
                <!-- Modal Header -->
                <div class="modal-header border-0 pb-0 justify-content-between align-items-center">
                  <h2 class="modal-title custom-modal-title">Choose payment method</h2>
                  <button type="button" class="close custom-close-x" @click="closeSelectionModal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Modal Body: Interactive Options Option Cards -->
                <div class="modal-body py-4 d-flex flex-column gap-3">
                  
                  <!-- Option 1: Pay with SAFE (Selected Active Indicator State) -->
                  <div 
                    class="payment-method-card d-flex align-items-center p-3"
                    :class="{ 'is-selected-active': selectedMethod === 'safe' }"
                    @click="selectedMethod = 'safe'"
                  >
                    <div class="method-icon-avatar d-flex align-items-center justify-content-center mr-3">
                      
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                      </svg>
                    </div>
                    <div class="method-metadata-text">
                      <h4 class="method-heading m-0">Pay with SAFE</h4>
                      <p class="method-subtext text-success font-weight-bold m-0 mt-1">
                        Available balance: ₦{{ activeProduct.user_safe_balance }}
                      </p>
                    </div>
                  </div>

                  <!-- Option 2: Pay In-store -->
                  <div 
                    class="payment-method-card d-flex align-items-center p-3"
                    :class="{ 'is-selected-active': selectedMethod === 'store' }"
                    @click="selectedMethod = 'store'"
                  >
                    <div class="method-icon-avatar d-flex align-items-center justify-content-center mr-3">
                      <!-- Bank/Store Building Icon Vector -->
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 22V11m18 11V11M1 11h22M11 2v4M4 6h16M2 22h20"/>
                      </svg>
                    </div>
                    <div class="method-metadata-text">
                      <h4 class="method-heading m-0">Pay In-store</h4>
                      <p class="method-subtext text-muted m-0 mt-1">Reserve item and pay at pickup</p>
                    </div>
                  </div>

                </div>

                <!-- Modal Footer: Call To Action Action Control -->
                <div class="modal-footer border-0 pt-0" v-if="selectedMethod === 'safe'">
                  <button type="button" class="btn btn-block continue-action-cta-btn" @click="handleContinuePipeline">
                    Continue
                  </button>
                </div>

                <div class="modal-footer border-0 pt-0" v-if="selectedMethod === 'store'">
                  <button :disabled="loading" type="button" class="btn btn-block continue-action-cta-btn" @click="buyProduct">
                    {{ loading ? 'Processing...' : 'Submit' }}
                  </button>
                </div>

              </div>
            </div>
          </div>
          <!-- Payment selection modal -->

          <div>
            <!-- <confirm-payment-modal 
              :base-amount="85000"
              :transaction-fee="25"
              :available-discount-pool="5000"
              @confirmed="openPinModalSequence"
            /> -->

            <!-- REUSABLE MODAL 2: SECURE PIN TERMINAL -->
            <!-- <secure-pin-modal 
              ref="securePinRef"
              :loading="apiProcessing"
              @submit-pin="executeFinalPaymentEndpoint"
            /> -->
          </div>

          <!-- MODAL 2: CONFIRMATION TERMINAL OVERLAY -->
          <div 
            class="modal fade" 
            id="paymentConfirmModal" 
            tabindex="-1" 
            role="dialog" 
            aria-hidden="true"
            ref="confirmModal"
          >
            <div class="modal-dialog modal-dialog-centered custom-modal-enclosure" role="document">
              <div class="modal-content custom-modal-card p-3 p-sm-4">
                
                <!-- Modal Header Block matching mockup layout alignment perfectly -->
                <div class="modal-header border-0 pb-0 justify-content-between align-items-start">
                  <div class="title-text-cluster">
                    <h2 class="modal-title custom-modal-title mb-1">Confirm Payment</h2>
                    <p class="modal-subtitle-warning text-muted m-0">
                      Please note that successful payment cannot be reversed.
                    </p>
                  </div>
                  <button type="button" class="close custom-close-x" @click="closeConfirmModal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Modal Body Block -->
                <div class="modal-body py-4">
                  
                  <!-- ₦ Hero Pricing Big Display Label Matrix -->
                  <div class="hero-amount-display text-center mb-4 font-weight-bold">
                    ₦{{ formatPrice(actualPrice * itemQuantity || actualPrice) }}
                    <!-- (cova_points * cova_rate) -->
                    <h5 class="discount-amount" v-if="isDiscountApplied && inputtedPoints != null">₦{{ (appliedDiscount * cova_rate)  }}</h5>
                    <!-- <p>{{ cova_points }}</p>
                    <span>{{ cova_rate }}</span> -->
                  </div>

                  <!-- Financial Calculation Breakdown Summary Box -->
                  <div class="receipt-breakdown-card p-3 d-flex flex-column gap-3">
                    
                    <!-- Row 1: Available Discount Layer -->
                    <div class="breakdown-row d-flex justify-content-between align-items-center">
                      <span class="row-label-text text-muted">Available discount</span>
                      <div class="d-flex align-items-center gap-2">
                        <span class="row-value-text font-weight-bold text-dark">
                          {{ activeProduct.user_cova_balance }}
                        </span>
                        <button 
                          type="button" 
                          class="badge-apply-btn" 
                          :class="{ 'is-active-open': isInputtingDiscount }"
                          @click="isInputtingDiscount = !isInputtingDiscount"
                        >
                          {{ isDiscountApplied ? 'Change' : 'Apply' }}
                        </button>
                      </div>
                    </div>

                    <!-- Collapsible Inline Input Drawer for Discount Points -->
                    <transition name="collapse-slide">
                      <div v-if="isInputtingDiscount" class="discount-input-drawer-canvas p-2 mt-1">
                        <label class="drawer-label-text text-muted mb-1">Enter Discount Points</label>
                        <div class="d-flex gap-2">
                          <input 
                            type="number" 
                            v-model.number="inputtedPoints"
                            class="form-control custom-points-field" 
                            placeholder="e.g. 5000"
                            min="0"
                            :max="cova_points"
                          />
                          <button type="button" class="submit-points-btn" @click="applyPointsToTotal">Ok</button>
                        </div>
                      </div>
                    </transition>

                    <div class="dotted-divider-line my-1"></div>

                    <div class="discount-input-drawer-canvas p-2 mt-1">
                      <label class="drawer-label-text text-muted mb-1">Enter Quantity</label>
                      <div class="d-flex gap-2">
                        <input 
                          type="number" 
                          v-model.number="itemQuantity"
                          class="form-control custom-points-field" 
                          placeholder="e.g. 1"
                          min="1"
                        />
                      </div>
                    </div>

                    <!-- Row 2: Reward Score Tracker -->
                    <!-- <div class="breakdown-row d-flex justify-content-between align-items-center d-none">
                      <span class="row-label-text text-muted">Reward</span>
                      <span class="row-value-text font-weight-bold text-dark">+20 points</span>
                    </div> -->

                    <!-- Dotted Divider Separation Line layout spec -->
                    <div class="dotted-divider-line my-1"></div>

                    <!-- Row 3: Transaction Fee Lock Ring -->
                    <!-- <div class="breakdown-row d-flex justify-content-between align-items-center">
                      <span class="row-label-text text-muted">Transaction fee</span>
                      <span class="row-value-text font-weight-bold text-primary-link">
                        ₦{{ formatPrice(transactionFee) }}
                      </span>
                    </div> -->

                    <!-- Row 4: Active Payment Strategy Target -->
                    <div class="breakdown-row d-flex justify-content-between align-items-center">
                      <span class="row-label-text text-muted">Payment method</span>
                      <span class="row-value-text font-weight-bold text-dark">
                        {{ selectedMethod == 'safe' ? 'SAFE Account' : 'Pay at store' }}
                      </span>
                    </div>

                  </div>
                </div>

                <!-- Modal Footer: Action Execution Control Stack -->
                <div class="modal-footer border-0 d-flex flex-column gap-2 pt-0">
                  <button 
                    type="button" 
                    class="btn btn-block primary-confirm-btn" 
                    :disabled="isSubmittingPayment"
                    @click="dispatchPaymentVerification"
                  >
                    {{ isSubmittingPayment ? 'Authorizing Payout Terminal...' : 'Confirm' }}
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-block secondary-cancel-btn" 
                    @click="closeConfirmModal"
                  >
                    Cancel
                  </button>
                </div>

              </div>
            </div>
          </div>

          <!-- SECURE BOOTSTRAP 4 TRANSACTION PIN MODAL -->
          <div 
            class="modal fade" 
            id="transactionPinModal" 
            tabindex="-1" 
            role="dialog" 
            aria-hidden="true"
            ref="pinModal"
          >
            <div class="modal-dialog modal-dialog-centered custom-modal-enclosure" role="document">
              <div class="modal-content custom-modal-card p-4 text-center">
                
                <!-- Modal Header Close Trigger -->
                <div class="modal-header border-0 pb-0 justify-content-end">
                  <button type="button" class="close custom-close-x" @click="closePinModal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Modal Body Core Input Form Box -->
                <div class="modal-body py-2">
                  <!-- Security Shield Vector Graphic Halo Ring -->
                  <div class="security-lock-halo mx-auto mb-4 d-flex align-items-center justify-content-center">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#0b44f2" stroke-width="2.5">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                  </div>
                  
                  <h3 class="pin-modal-title mb-2">Enter Transaction PIN</h3>
                  <p class="pin-modal-subtitle text-muted px-2 mb-4">
                    Please enter your 4-digit security wallet code to authorize this transaction payment.
                  </p>

                  <!-- THE 4-DIGIT INPUT MATRIX RAIL -->
                  <div class="pin-inputs-row d-flex justify-content-center gap-3 mb-4">
                    <input 
                      v-for="(digit, idx) in 4" 
                      :key="idx"
                      :id="'pin-digit-' + idx"
                      ref="pinInputs"
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      class="form-control pin-box-field text-center font-weight-bold"
                      v-model="pinDigits[idx]"
                      @input="handleInputFocusForward($event, idx)"
                      @keydown.delete="handleInputFocusBackward($event, idx)"
                      @paste="handlePasteClipboard"
                      autocomplete="one-time-code"
                    />
                  </div>
                </div>

                <!-- Modal Footer Actions Stack -->
                <div class="modal-footer border-0 d-flex flex-column gap-2 pt-0">
                  <button 
                    type="button" 
                    class="btn btn-block primary-pay-btn" 
                    :disabled="!isPinComplete || isAuthorizingPayment"
                    @click="payWithSafePin"
                  >
                    <span v-if="!isAuthorizingPayment">Authorize & Pay</span>
                    <span v-else>Processing Security Vault...</span>
                  </button>
                  <button type="button" class="btn btn-block secondary-cancel-btn" @click="closePinModal">
                    Cancel
                  </button>
                </div>

              </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // @ts-nocheck
  import Vue from 'vue';
  import { Service } from "../../store/service";
  const Api = new Service();
  import $ from "jquery";
  
  export default Vue.extend({
    name: 'ProductDetails',
    data() {
      return {
        loading: false,
        activeImageIndex: 0,
        isProcessingBuy: false,
        isProcessingCart: false,
        numericValue: 0,
        // Master Schema Dataset reflecting the exact details visible in the image mockup
        activeProduct: {},
        itemQuantity: 1,
        product: {
          id: "prod-hisense-43a6k",
          title: 'Hisense 43" 4K UHD Smart Frameless TV (43A6K)',
          ratingScore: 4.7,
          reviewCount: 128,
          merchantName: 'Konga Direct',
          images: [
            // Utilizing high-resolution representation path tracking the active product design image
            require('../../assets/images/prop1.svg'),
            require('../../assets/images/prop5.svg'),
          ],
          specifications: {
            dimensions: '112"W x 70"D x 32"H',
            material: 'Italian Linen Blend'
          }
        },
        paymentInfo: {
            monthlyAmount: 2400000,
            durationMonths: 2
        },
        merchant: {
            name: 'Urban Tech Solutions',
            avatarUrl: 'https://unsplash.com'
        },
        reviews: [
            {
            id: 1,
            authorName: 'Julian Steven.',
            ratingScore: 5,
            comment: 'Exceeded expectations. The fabric is incredibly durable and cleans up easily even with kids and pets.'
            },
            {
            id: 2,
            authorName: 'Ayo Mkun.',
            ratingScore: 4,
            comment: 'Exceeded expectations. The fabric is incredibly durable and cleans up easily even with kids and pets.'
            },
            {
            id: 3,
            authorName: 'Emeka Samuel.',
            ratingScore: 3,
            comment: 'Exceeded expectations. The fabric is incredibly durable and cleans up easily even with kids and pets.'
            }
        ],
        selectedMethod: 'safe', // 'safe' matches your top default blue card option view state
        isSubmittingTransaction: false,
        walletBalance: 2450.00,
        availableDiscountPool: 5000.00,
        appliedDiscount: 0,
        transactionFee: 25.00,
        inputtedPoints: null,
        isInputtingDiscount: false,
        isDiscountApplied: false,
        isSubmittingPayment: false,
        pinDigits: ['', '', '', ''], // Holds the 4 split string tokens
        isAuthorizingPayment: false,

        cova_points: 0,
        cova_rate: 0,
        actualPrice: 0,

      };
    },
    created() {
      const savedPayload = localStorage.getItem('selected_product');
    
      if (savedPayload) {
        this.activeProduct = JSON.parse(savedPayload);
        // this.numericValue = Number(stringValue.replace(/,/g, ''));
        this.cova_points =  Number(this.activeProduct.user_cova_balance.replace(/,/g, ''));
        this.cova_rate = Number(this.activeProduct.cova_rate);

        console.log("Product Item", this.activeProduct)

        if (this.activeProduct.payment_type === 'outright_payment') {
          this.actualPrice = this.activeProduct.price;
          console.log("Outrigth", this.actualPrice)
        }
        if (this.activeProduct.payment_type === 'payment_plan') {
          this.actualPrice = this.activeProduct.down_payment_actual_value;
          console.log("Plan", this.actualPrice)
        }
        // console.log('[Details Component] Active selection parsed successfully:', this.activeProduct);
      }
    },
    computed: {
      activeImage() {
        return this.activeProduct.images[this.activeImageIndex] || '';
      },
      readableMethodName() {
        return this.selectedMethod === 'safe' ? 'SAFE Wallet' : 'In-Store Pickup';
      },
      computedGrandTotal() {
        // Automatic mathematical balance calculation: Base + Fee - Applied Discounts
        return this.basePriceAmount + this.transactionFee - this.appliedDiscount;
      },
      computedGrandTotal() {
        // Automatic mathematical balance calculation: Base + Fee - Applied Discounts
        return this.actualPrice - this.appliedDiscount;
      },
      isPinComplete() {
        // Validates that every slot in the grid contains exactly one numeric character string
        // return this.pinDigits.every(digit => digit !== '' && /^\d+\$/.test(digit));
        return this.pinDigits.every(digit => digit !== '' && !isNaN(digit));
      },
      compiledPinString() {
        return this.pinDigits.join('');
      }
    },
    beforeDestroy() {
      localStorage.removeItem('selected_product');
      // console.log('[Details Component] Left context path view. Active selected storage wiped.');
    },
    methods: {
        switchActiveImageIndex(index) {
            if (index >= 0 && index < this.activeProduct.images.length) {
            this.activeImageIndex = index;
            }
        },
        
        // THE CAROUSEL STEP FUNCTION
        advanceToNextImage() {
            // If we are on the last image, wrap cleanly back to index 0, otherwise increment
            if (this.activeImageIndex >= this.activeProduct.images.length - 1) {
            this.activeImageIndex = 0;
            } else {
            this.activeImageIndex++;
            }
            console.log(`[Carousel Swipe]: Advanced dynamically to active slide view index: ${this.activeImageIndex}`);
        },

        triggerBackAction() {
            console.log('[Navigation]: Back action triggered');
            // Implement your routing logic context path here (e.g., this.\$router.back())
        },

        dispatchInstantBuyTerminal() {
            this.isProcessingBuy = true;
            setTimeout(() => {
            this.isProcessingBuy = false;
            this.$emit('buy-now', { productId: this.activeProduct.id, quantity: 1 });
            }, 1000);
        },

        dispatchCartAppendPipeline() {
            this.isProcessingCart = true;
            setTimeout(() => {
            this.isProcessingCart = false;
            this.$emit('add-to-cart', { productId: this.activeProduct.id, quantity: 1 });
            }, 800);
        },

        formatPrice(val) {
            let price = Number(val)
            return price.toLocaleString('en-NG');
        },
        getInitials(name) {
            if (!name) return 'U';
            const parts = name.trim().split(' ');
            if (parts.length >= 2) {
                return (parts[0][0] + parts[1][0]).toUpperCase();
            }
            return name.slice(0, 2).toUpperCase();
        },
        openSelectionModal() {
          // Accessing standard Bootstrap 4 jQuery triggers natively inside Vue wrappers
          $('#paymentSelectionModal').modal('show');
          // $("#addCoach")
          // .removeClass("fade")
          // .modal("hide");
        },
        closeSelectionModal() {
          $('#paymentSelectionModal').modal('hide');
        },
        closeConfirmationModal() {
          $('#paymentConfirmationModal').modal('hide');
        },
        closeConfirmModal() {
          $('#paymentConfirmModal').modal('hide');
        },
        closeAllModals() {
          this.closeSelectionModal();
          this.closeConfirmationModal();
        },
        handleContinuePipeline() {
          // 1. Close current selection backdrop window box
          this.closeSelectionModal();
          
          // 2. Queue sequence transition shift to open confirmation layout frame window
          setTimeout(() => {
            $('#paymentConfirmModal').modal('show');
          }, 350);
        },
        dispatchFinalizeTransaction() {
          this.isSubmittingTransaction = true;
          console.log(`[Terminal Transaction Dispatch]: Finalizing strategy allocation rules for: ${this.selectedMethod}`);
          
          setTimeout(() => {
            this.isSubmittingTransaction = false;
            this.closeAllModals();
            this.$emit('payment-selected', {
              methodType: this.selectedMethod,
              timestamp: new Date()
            });
          }, 1500);
        },
        applyPointsToTotal() {
          const points = Number(this.inputtedPoints);
          if (isNaN(points) || points < 0) {
            this.appliedDiscount = 0;
            this.isDiscountApplied = false;
          } else if (points > this.cova_points) {
            this.appliedDiscount = this.cova_points;
            this.isDiscountApplied = true;
          } else {
            this.appliedDiscount = points;
            this.isDiscountApplied = true;
          }
          this.isInputtingDiscount = false; // Hide input canvas smoothly
        },
        dispatchPaymentVerification() {
          this.isSubmittingPayment = true;
          this.closeConfirmModal();
  
          // setTimeout(() => {
          //   this.isSubmittingPayment = false;
          //   this.closeConfirmModal();
          //   this.$emit('payment-success', {
          //     finalAmount: this.computedGrandTotal,
          //     discountDeducted: this.appliedDiscount,
          //     timestamp: new Date()
          //   });
          // }, 1600);
          this.openPinModal();
        },

        openPinModal() {
          this.pinDigits = ['', '', '', '']; // Reset array states on mount opening
          $('#transactionPinModal').modal('show');
          // Focus on the first box input index slot after animation triggers
          setTimeout(() => {
            const firstInput = document.getElementById('pin-digit-0');
            if (firstInput) firstInput.focus();
          }, 400);
        },
        closePinModal() {
          $('#transactionPinModal').modal('hide');
        },
        handleInputFocusForward(event, index) {
          const value = event.target.value;
          // Sanitize input character tokens strictly to numeric values
          if (value === '' || isNaN(value)) {
            this.pinDigits[index] = '';
            return;
          }

          // Take only the last character entered (fixes double typing glitches on mobile)
          this.pinDigits[index] = value.slice(-1)


          // Advance cursor focus layer to the next square grid block automatically
          if (value && index < 3) {
            const nextField = document.getElementById(`pin-digit-${index + 1}`);
            if (nextField) nextField.focus();
          }
        },
        handleInputFocusBackward(event, index) {
          // Detect backspace deletion key inputs
          if (this.pinDigits[index] === '' && index > 0) {
            const previousField = document.getElementById(`pin-digit-${index - 1}`);
            if (previousField) {
              previousField.focus();
              this.pinDigits[index - 1] = ''; // Wipe preceding index
            }
          }
        },
        handlePasteClipboard(event) {
          const text = (event.clipboardData || window.clipboardData).getData('text');
          if (/^\d{4}\$/.test(text.trim())) {
            this.pinDigits = text.trim().split('');
            document.getElementById('pin-digit-3').focus();
          }
          event.preventDefault();
        },
        async payWithSafePin() {
          this.isAuthorizingPayment = true;
          this.loading = true;
          try {
            await Api.postRequest(`verify-transaction-pin`, {pin: this.compiledPinString})
            .then(res => {
              this.loading = false;
              // console.log("pin verified", res)
              if (res.data.success && res.data.message === 'verified') {
                this.buyProduct();   
                // return this.$store.commit("setApiSuccess", "Success");
              }
              if (res.data.error) {
                return this.$store.commit("setApiFailed", res.data.error);
              }
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
            });
          } finally {
            // console.log("closed")
          } 
          
          // setTimeout(() => {
          //   this.isAuthorizingPayment = false;
          //   this.closePinModal();
          //   this.$emit('pin-verified', { pin: this.compiledPinString, timestamp: new Date() });
          // }, 1800);
        },

        async buyProduct() {
          this.loading = true;
          try {
            await Api.postRequest(`buy-now-from-corporate`, {
              product_id: this.activeProduct.id,
              payment_method: this.selectedMethod,
              cova_points: this.inputtedPoints,
              quantity: Number(this.itemQuantity),
            }).then(res => {
              // console.log("Purchased data", res);
              this.loading = false;
              if (res.data.success) {
                this.closePinModal();  
                $('#paymentSelectionModal').modal('hide');
                this.$router
                    .push({
                    path: `/dashboard/products`
                    })
                    .catch(() => {
                });
              }
            }).catch(err => {
              console.log('Error:', err);
              this.loading = false;
            })
          } finally {
            // console.log("closed")
          }
        }
      }
  });
</script>


<style lang="scss" scoped>
// Variables local references binding back cleanly to your global typography rules
$font-sans: 'Public Sans', system-ui, -apple-system, sans-serif;
$color-navy-primary: #0022ba; // Matching the deep cobalt buy button hex color token parameter precisely
$color-bg-panel: #f8fafc;
$color-border-ring: #e2e8f0;
$color-text-dark: #0f172a;
$color-text-muted: #64748b;

$font-sans: 'Public Sans', system-ui, -apple-system, sans-serif;
$color-primary-blue: #0b44f2; // High contrast modern digital blue hex matching mockup image button precisely
$color-border-card: #e2e8f0;
$color-dark-main: #0c1a30;
$color-apply-orange: #ffb01f;
$color-brand-blue: #0b44f2;


.product-details-canvas {
  font-family: $font-sans;
  background-color: #ffffff;
  color: $color-text-dark;
  min-height: 100vh;
  box-sizing: border-box;
}

/* ─── 📸 GALLERIES HERO VIEW BOX STAGE ─── */
.hero-stage-panel {
  position: relative;
  background: radial-gradient(circle at 50% 50%, #e0f2fe 0%, #bae6fd 70%, #7dd3fc 100%); // Waves design overlay blueprint tint mapping
  border-radius: 20px;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  box-shadow: inset 0 0 40px rgba(0, 0, 0, 0.02);

  .active-showcase-asset {
    max-height: 85%;
    max-width: 85%;
    object-fit: contain;
    filter: drop-shadow(0 20px 30px rgba(15, 23, 42, 0.15));
  }
}

.back-navigation-btn {
  top: 16px;
  left: 16px;
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.08);
  }
}

.slide-indicator-badge {
  bottom: 16px;
  right: 16px;
  background-color: rgba(15, 23, 42, 0.5); // Frosted layout indicators strip
  color: #ffffff;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  letter-spacing: 0.05em;
  backdrop-filter: blur(4px);
}

/* ─── 🏷️ PRODUCT INFORMATION CORE AND SPECIFICATIONS ─── */
.product-title-header {
  font-family: $font-sans;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.3;
  color: #0d1b3e; // Deep navy text matching mockup specification header layers
  letter-spacing: -0.01em;
  text-align: left;
}

.score-badge-pill {
  background-color: #eff6ff;
  padding: 4px 8px;
  border-radius: 6px;

  .star-icon-solid {
    color: #2563eb; // High contrast blue rating star matching mockup criteria exactly
    font-size: 0.85rem;
  }

  .rating-value-bold {
    font-size: 0.85rem;
    font-weight: 800;
    color: #2563eb;
  }
}

.review-total-count {
  font-size: 0.85rem;
  font-weight: 600;
}

.divider-dot {
  color: #cbd5e1;
  font-size: 0.8rem;
}

.availability-status-tag {
  font-size: 0.8rem;
  font-weight: 700;
  color: #16a34a;
}

.merchant-partnership-row {
  font-size: 0.875rem;
  font-weight: 500;
  text-align: left;

  .merchant-highlight-name {
    color: $color-text-dark;
    font-weight: 700;
  }
  
  .partnership-badge-tag {
    font-size: 0.8rem;
    color: $color-text-muted;
  }
}

/* 📋 SPECIFICATIONS LAYOUT MATRIX GRID */
.specification-title-label {
  font-size: 1.1rem;
  font-weight: 800;
  color: #334155;
  letter-spacing: -0.01em;
  text-align: left;
}

.spec-data-row {
  font-size: 0.95rem;
  align-items: center;

  .spec-property-label {
    font-weight: 500;
  }

  .spec-value-content-text {
    font-size: 0.95rem;
    font-weight: 600;
    text-align: right;
  }
}

.reviewer-meta {
    gap: 5px;
}

.payment-plan-card {
  box-shadow: 0px 4px 20px 0px #0000000D;
  padding: 15px;
}

/* ─── 💳 ACTION DOCK CONTROLS STICKY BUTTONS ─── */
.buy-now-action-cta-btn {
  background-color: $color-navy-primary;
  color: #ffffff;
  border: none;
  height: 52px; // Optimized hit targets matching touchscreen mobile accessibility dimensions
  border-radius: 26px; // Completely round pill configuration matching the image mockup design
  font-size: 1.05rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 34, 186, 0.15);
  transition: background-color 0.2s ease, transform 0.2s ease;

  &:hover:not(:disabled) {
    background-color: lighten($color-navy-primary, 5%);
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:disabled {
    background-color: $color-text-muted;
    cursor: not-allowed;
    box-shadow: none;
  }
}

.discount-amount {
  font-family: Lato;
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  text-decoration: line-through;
  color: #9CA3AF;
  // line-height: 40px;
  margin-bottom: 20px;
}

.cart-bucket-append-dock-btn {
  width: 52px;
  height: 52px;
  background-color: #ffffff;
  border: 1px solid $color-border-ring;
  color: $color-navy-primary;
  border-radius: 50%; // Circular auxiliary utility trigger
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f8fafc;
    border-color: $color-text-muted;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

/* ─── 📱 RESPONSIVE VIEWPORT BREAKPOINTS (Pure CSS Media Queries) ─── */
@media (min-width: 768px) {
  .product-title-header {
    font-size: 2rem;
    line-height: 1.25;
  }

  .hero-stage-panel {
    aspect-ratio: 4 / 4.5; // Elongates view canvas parameters automatically on large presentation screens
    padding: 3rem;
  }
  
  .spec-data-row {
    padding: 14px 0 !important; // Gives specification columns clear room layout spacing on desktop screens
  }
}

.product-details-extended {
  font-family: $font-sans;
  background-color: #ffffff;
  color: $color-text-dark;
  box-sizing: border-box;
}

/* ─── 💳 PAYMENT PLAN MODULE ROWS ─── */
.section-title-label {
  font-size: 1.25rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;
  text-align: left;
}

.plan-data-row {
  font-size: 0.95rem;

  .plan-property-label {
    font-weight: 500;
  }

  .plan-value-highlight {
    font-size: 1.05rem;
    font-weight: 800;
    // color: $color-navy-primary !important;
    color: #0B1C30 !important;
  }
}
.plan-data-row:last-child {
  border-bottom: none !important;
  font-size: 20px !important;
}

/* ─── 👤 MERCHANT CARD WRAPPER ─── */
.merchant-profile-card {
  background-color: #f3f6ff; // Accurate light secondary blue highlight tint from design mockup
  border-radius: 14px;
  box-sizing: border-box;
  gap: 10px;

  .merchant-avatar-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    .merchant-avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .merchant-badge-label {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .merchant-name-title {
    font-size: 1rem;
    font-weight: 800;
    color: #0f172a;
  }
}

/* ─── 💬 CUSTOMER REVIEWS LIST ─── */
.reviewer-initials-avatar {
  width: 36px;
  height: 36px;
  background-color: #e2e8f0;
  color: #475569;
  font-size: 0.85rem;
  font-weight: 700;
  border-radius: 50%;
  letter-spacing: 0.02em;
}

.reviewer-name-text {
  font-size: 0.95rem;
  font-weight: 800;
  color: #0f172a;
}

.review-stars-row {
  .star-glyph {
    color: #e2e8f0; // Empty baseline grey star tracker glyph
    font-size: 0.85rem;
    transition: color 0.2s ease;

    &.is-filled {
      color: #ffd073; // Vibrant filled brand orange-yellow highlight star indicator token
    }
  }
}

.review-body-content {
  padding-left: 44px; // Mobile optimized indentation to align paragraphs right below the names profile tracks
  
  .review-text-paragraph {
    font-size: 0.925rem;
    line-height: 1.5;
    font-style: italic;
    text-align: left;
  }
}

/* ─── 📱 RESPONSIVE VIEWPORT BREAKPOINTS (Pure CSS Media Queries) ─── */
@media (min-width: 640px) {
  .section-title-label {
    font-size: 1.5rem;
  }

  .plan-data-row {
    padding: 18px 0 !important;
    
    .plan-value-highlight {
      font-size: 1.2rem;
    }
  }

  .merchant-profile-card {
    padding: 1.25rem !important;

    .merchant-avatar-wrapper {
      width: 56px;
      height: 56px;
    }
  }
}

.customer-reviews-section {
    box-shadow: 0px 4px 20px 0px #0000000D;
    padding: 15px;
}


.payment-modal-wrapper {
  font-family: $font-sans;
  box-sizing: border-box;
}

.main-trigger-btn {
  font-family: $font-sans;
  background-color: $color-primary-blue;
  border-color: $color-primary-blue;
  font-weight: 700;
  padding: 12px 24px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(11, 68, 242, 0.15);
  
  &:hover { background-color: darken($color-primary-blue, 5%); }
}

/* 🏢 CUSTOM BOOTSTRAP MODERN MODAL SURFACES */
.custom-modal-enclosure {
  max-width: 460px; // Standard production mobile profile enclosure width match
  width: 100%;
}

.custom-modal-card {
  border-radius: 28px !important; // Smooth high-radius micro corners matching the mockup frame perfectly
  border: 1px solid #ffffff;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.15);
  background-color: #ffffff;
}

.custom-modal-title {
  font-size: 1.35rem;
  font-weight: 800;
  color: $color-dark-main;
  letter-spacing: -0.01em;
  line-height: 1.25;
}

.custom-close-x {
  padding: 0.5rem !important;
  margin: -0.5rem -0.5rem -0.5rem auto !important;
  font-size: 1.5rem;
  color: #94a3b8;
  outline: none !important;
  opacity: 0.7;

  &:hover { color: #dc2626; opacity: 1; }
}

/* 💳 INTERACTIVE SELECTION GRID CARDS */
.payment-method-card {
  border: 1.5px solid #f1f5f9;
  border-radius: 18px; // Capsule styling boundaries matching card layout tracks precisely
  background-color: #ffffff;
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover:not(.is-selected-active) {
    background-color: #f8fafc;
    border-color: #cbd5e1;
  }

  // 🎯 THE MOCKUP INDICATOR LOOK: Active blue border mapping
  &.is-selected-active {
    border-color: $color-primary-blue;
    background-color: #ffffff;
    box-shadow: 0 0 0 1px $color-primary-blue; // Double accent track mapping line depth
  }
}

.method-icon-avatar {
  width: 48px;
  height: 48px;
  background-color: #f1f5f9;
  border-radius: 50%;
  color: #334155;
  flex-shrink: 0;
  
  .is-selected-active & {
    background-color: #f1f5f9;
    color: $color-dark-main;
  }
}

.method-heading {
  font-size: 1.05rem;
  font-weight: 700;
  color: $color-dark-main;
}

.method-subtext {
  font-size: 0.85rem;
  line-height: 1.4;

  &.text-success {
    color: #16a34a !important; // Clean high contrast green matching design available balance text
  }
}

// /* 🚀 MASTER ACTIONS PRIMARY CTA BLUE BUTTONS */
.continue-action-cta-btn, .finalize-pay-btn {
  background-color: $color-primary-blue !important;
  color: #ffffff !important;
  border: none;
  height: 54px; // Large comfortable touch area dimensions matching mockup height specs perfectly
  border-radius: 16px !important; // Rounded pill action layout
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  transition: background-color 0.2s ease, transform 0.1s ease;
  outline: none !important;

  &:hover { background-color: darken($color-primary-blue, 5%) !important; }
  &:active { transform: scale(0.99); }
}

/* STAGE 2: FINAL CONFIRMATION SPECIFICS */
.second-modal-layer-z {
  z-index: 1060 !important; // Forces the final step card to overlap layout properties cleanly
}

.confirmation-icon-halo {
  width: 76px;
  height: 76px;
  background-color: $color-primary-blue;
  border-radius: 50%;
  box-shadow: 0 8px 16px rgba(11, 68, 242, 0.2);
}

.confirm-title {
  font-size: 1.25rem;
  font-weight: 800;
  color: $color-dark-main;
}

.finalize-pay-btn {
  &:disabled {
    background-color: #94a3b8 !important;
    cursor: not-allowed;
  }
}

// Custom gap utility layout spacing overrides for Bootstrap 4 stacks
.gap-3 { gap: 1rem !important; }



.modal-subtitle-warning {
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.4;
}

.custom-close-x {
  padding: 0.5rem !important;
  margin: -0.5rem -0.5rem -0.5rem auto !important;
  font-size: 1.5rem;
  color: #94a3b8;
  outline: none !important;

  &:hover { color: #dc2626; }
}

/* ₦ HERO PRICING DISPLAYS */
.hero-amount-display {
  font-size: 2.25rem;
  font-weight: 800;
  color: $color-dark-main;
  letter-spacing: -0.02em;
}

/* 📊 RECIEPT BREAKDOWN CARD PATTERNS */
.receipt-breakdown-card {
  background-color: #f8fafc; // Soft light gray backdrop layout from image spec
  border-radius: 18px;
  box-sizing: border-box;
}

.breakdown-row {
  font-size: 0.95rem;

  .row-label-text {
    font-weight: 500;
  }

  .row-value-text {
    font-weight: 700;
    color: $color-dark-main;
  }

  .text-primary-link {
    color: #3b82f6 !important; // High contrast digital accent blue transaction fee text string
  }
}

.dotted-divider-line {
  width: 100%;
  height: 1px;
  border-top: 2px dashed #e2e8f0; // Dotted separator tracking mockup layout
}

/* 🏷️ GOLDEN ORANGE APPLY BADGE ACTION PRIMITIVES */
.badge-apply-btn {
  background-color: $color-apply-orange;
  color: #ffffff;
  border: none;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 12px; // Capsule shape matching mockup badge precisely
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  outline: none !important;

  &:hover { background-color: darken($color-apply-orange, 5%); }
  &.is-active-open { background-color: $color-text-muted; }
}

/* 📋 COLLAPSIBLE POINT INPUT DRAWER STYLE */
.discount-input-drawer-canvas {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;

  .drawer-label-text {
    font-size: 0.7rem;
    font-weight: 700;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .custom-points-field {
    height: 36px;
    font-size: 0.875rem;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    outline: none;

    &:focus {
      border-color: $color-brand-blue;
      box-shadow: 0 0 0 3px rgba(11, 68, 242, 0.06);
    }
  }

  .submit-points-btn {
    background-color: $color-dark-main;
    color: #ffffff;
    border: none;
    font-weight: 700;
    padding: 0 14px;
    border-radius: 6px;
    height: 36px;
    font-size: 0.85rem;
    cursor: pointer;

    &:hover { background-color: lighten($color-dark-main, 10%); }
  }
}

/* 🚀 MASTER ACTION ACTION PRIMARY & SECONDARY BUTTONS STACK */
.primary-confirm-btn {
  background-color: $color-brand-blue !important;
  color: #ffffff !important;
  border: none;
  height: 52px; // Large physical touch target matching mockup dimension height specs precisely
  border-radius: 16px !important; // Rounded box pill styling
  font-size: 1.05rem;
  font-weight: 700;
  transition: background-color 0.2s ease;
  outline: none !important;

  &:hover { background-color: darken($color-brand-blue, 5%) !important; }
  &:disabled { background-color: #94a3b8 !important; cursor: not-allowed; }
}

.secondary-cancel-btn {
  background-color: #eff6ff !important; // Light high contrast gray-blue fallback tint from image spec
  color: #2563eb !important;
  border: none;
  height: 52px;
  border-radius: 16px !important;
  font-size: 1.05rem;
  font-weight: 700;
  transition: all 0.2s ease;
  outline: none !important;

  &:hover { background-color: #dbeafe !important; }
}

/* INTERACTIVE OPEN INPUT DRAWER COLLAPSE SLIDE TRANSITION */
.collapse-slide-enter-active, .collapse-slide-leave-active {
  transition: all 0.2s ease-out;
}
.collapse-slide-enter, .collapse-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

// Global flex gap auxiliary helper spacing overrides for Bootstrap 4 structural compatibility
.gap-2 { gap: 0.5rem !important; }
.gap-3 { gap: 1rem !important; }


.pin-modal-wrapper {
  font-family: $font-sans;
  box-sizing: border-box;
}

.demo-trigger-btn {
  background-color: $color-brand-blue;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(11, 68, 242, 0.15);
}

/* 🏢 BOOTSTRAP OVERLAY CONTAINER COMPONENT SURFACES */
.custom-modal-enclosure {
  max-width: 440px;
  width: 100%;
}

.custom-modal-card {
  border-radius: 28px !important; // Smooth high-radius micro corners matching your application profile
  border: none;
  background-color: #ffffff;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.15);
}

.pin-modal-title {
  font-size: 1.35rem;
  font-weight: 800;
  color: $color-dark-main;
  letter-spacing: -0.01em;
}

.pin-modal-subtitle {
  font-size: 0.9rem;
  line-height: 1.45;
}

.custom-close-x {
  padding: 0.5rem !important;
  margin: -0.5rem -0.5rem -0.5rem auto !important;
  font-size: 1.5rem;
  color: #94a3b8;
  outline: none !important;

  &:hover { color: #dc2626; }
}

.security-lock-halo {
  width: 72px;
  height: 72px;
  background-color: #eff6ff; // Light primary blue accent circle background ring
  border-radius: 50%;
}

/* 🔢 THE 4 PIN BOX FIELDS SPECIFICS */
.pin-box-field {
  width: 56px;
  height: 60px; // Large tactile square dimensions optimized for phone viewports thumb targets
  font-size: 1.75rem;
  background-color: #f8fafc; // Clean gray backdrop contrast container fill
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  outline: none !important;
  box-shadow: none !important;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);

  -webkit-text-security: disc !important; 
  // text-security: disc !important;

  // Active user selection indicator ring state mapping
  &:focus {
    background-color: #ffffff;
    border-color: $color-brand-blue;
    box-shadow: 0 0 0 4px rgba(11, 68, 242, 0.1) !important;
  }
}

/* 🚀 MASTER ACTION ACTION PRIMARY & SECONDARY BUTTONS STACK */
.primary-pay-btn {
  background-color: $color-brand-blue !important;
  color: #ffffff !important;
  border: none;
  height: 52px;
  border-radius: 16px !important; // Pill box rounded shape
  font-size: 1.05rem;
  font-weight: 700;
  transition: background-color 0.2s ease, transform 0.1s ease;
  outline: none !important;

  &:hover:not(:disabled) { background-color: darken($color-brand-blue, 5%) !important; }
  &:active:not(:disabled) { transform: scale(0.99); }
  &:disabled { background-color: #94a3b8 !important; cursor: not-allowed; opacity: 0.6; }
}

.secondary-cancel-btn {
  background-color: #f8fafc !important;
  color: $color-text-muted !important;
  border: 1px solid #e2e8f0;
  height: 52px;
  border-radius: 16px !important;
  font-size: 1.05rem;
  font-weight: 700;
  transition: all 0.2s ease;
  outline: none !important;

  &:hover { background-color: #edf2f7; color: $color-dark-main !important; }
}

// Global flex gap auxiliary helper spacing overrides for Bootstrap 4 structural compatibility
.gap-2 { gap: 0.5rem !important; }
.gap-3 { gap: 1rem !important; }
</style>

  